import { Layout as AntLayout, Button, Drawer } from 'antd';
import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { SideBar } from './Sidebar';
import { RxHamburgerMenu } from 'react-icons/rx';
import { Navbar } from './Navbar';
import { NavbarSkeleton, SidebarSkeleton } from '@src/components';
import { useTheme } from '@src/theme';

const { Header } = AntLayout;

export function Layout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { theme } = useTheme();

    return (
        <div
            className="flex justify-center h-screen"
            style={{ backgroundColor: theme.semantic.body }}
        >
            <div className="flex h-full w-full">
                {/* Sidebar */}
                <div className="hidden md:flex w-auto m-2 rounded-xl">
                    <Suspense fallback={<SidebarSkeleton />}>
                        <SideBar onSelect={() => setSidebarOpen(false)} />
                    </Suspense>
                </div>

                {/* Main Content Area */}
                <div className="flex flex-col flex-1 min-w-0">
                    <Header
                        className="px-5 py-0 md:py-2 h-auto text-lg font-semibold flex items-center"
                        style={{ backgroundColor: theme.semantic.body }}
                    >
                        {/* Hamburger Button for Mobile */}
                        <Button
                            type="text"
                            icon={<RxHamburgerMenu />}
                            className="md:hidden mr-4"
                            onClick={() => setSidebarOpen(true)}
                        />
                        <Suspense fallback={<NavbarSkeleton />}>
                            <Navbar />
                        </Suspense>
                    </Header>

                    <main
                        className="flex-1 overflow-auto p-4 sm:p-6 pt-8 mb-2 mr-2 ml-2 sm:ml-0 rounded-xl"
                        style={{ backgroundColor: theme.semantic.surface }}
                    >
                        <Outlet />
                    </main>
                </div>
                <Drawer
                    width="auto"
                    placement="left"
                    onClose={() => setSidebarOpen(false)}
                    open={sidebarOpen}
                    rootClassName="md:hidden"
                    styles={{
                        body: {
                            backgroundColor: '#f3f4f6',
                            padding: 0,
                        },
                        header: {
                            backgroundColor: '#f3f4f6',
                            margin: 0,
                        },
                        content: {
                            width: 'auto',
                        },
                    }}
                >
                    <Suspense fallback={<SidebarSkeleton />}>
                        <SideBar
                            isMobile={true}
                            onSelect={() => setSidebarOpen(false)}
                        />
                    </Suspense>
                </Drawer>
            </div>
        </div>
    );
}
